import { Component } from 'react';
import Chart from 'common/chartjs/register';
import BaseChart from 'legacy/javascripts/components/base_chart.es6';

class CategoriesHorizontalBarChart extends Component {
  drawLabelsNextToBars(animation, datasets) {
    let chartInstance = animation.chart;
    let ctx = chartInstance.ctx;
    const fontFamily = 'Nunito';
    const fontSize = Chart.defaults.font.size || 14;
    const fontStyle = Chart.defaults.font.style || 'normal';

    ctx.font = `${fontStyle} ${fontSize}px ${Chart.defaults.font.family}`;

    ctx.textAlign = 'center';
    ctx.textBaseline = 'bottom';

    datasets.forEach((dataset, i) => {
      const meta = chartInstance.getDatasetMeta(i);
      meta.data.forEach((bar, index) => {
        const data = dataset.data[index];
        ctx.font = `10pt ${fontFamily}`;
        ctx.fillStyle = '#000000';
        const label = `${data}%`;
        ctx.fillText(label, bar.x + 20, bar.y + 8);
      });
    });
  }

  render() {
    const options = {
      plugins: {
        legend: { display: false },
        tooltip: {
          enabled: false,
        },
      },
      layout: {
        padding: {
          left: 15,
          right: 0,
          top: 0,
          bottom: 0,
        },
      },
      ...(this.props.type === 'bar' ? { indexAxis: 'y' } : {}),
      scales: {
        x: {
          ticks: {
            suggestedMax: this.props.chartMax,
            beginAtZero: true,
            display: false,
          },
          grid: {
            display: false,
            drawBorder: false,
          },
        },
        y: {
          grid: {
            display: false,
            drawBorder: false,
          },
        },
      },
      animation: {
        duration: 1,
        onComplete: animation => {
          this.drawLabelsNextToBars(animation, this.props.datasets);
        },
      },
    };
    return (
      <BaseChart
        id={this.props.id}
        type={this.props.type}
        labels={this.props.columns}
        datasets={this.props.datasets}
        options={options}
      />
    );
  }
}

export default CategoriesHorizontalBarChart;
/* eslint-enable no-undef */
/* eslint-enable react/no-deprecated */
